import KendoDatePickerViewModelBase from '@/Components/KendoDateTimePicker/ViewModels/KendoDatePickerViewModelBase';
import ComponentManager from '@/Management/ComponentManager';
import * as DateHelper from '@/Utility/DateHelper'
import LinkViewModelT from '@/ViewModels/Controls/LinkViewModel';
import LabelViewModelT from '@/ViewModels/Controls/LabelViewModel';
import ImageViewModelT from '@/ViewModels/Controls/ImageViewModel';
import ResourceManager from '@/Management/ResourceManager';
import GlobalConfiguration from '@/Management/GlobalConfiguration';

export default class KendoDatePickerViewModel extends KendoDatePickerViewModelBase {

    private LinkViewModel = ComponentManager.getViewModel<typeof LinkViewModelT>('LinkViewModel');
    private ImageViewModel = ComponentManager.getViewModel<typeof ImageViewModelT>('ImageViewModel');
    private LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelT>('LabelViewModel');

    /**
     * Das ViewModel für den Link zum Auwählen eines Datums
     */
    public link: LinkViewModelT;

    public constructor(params: any) {
        super(params);
        
        this.link = this.createLinkViewModel();
    }

    /**
     * @override
     * @inheritdoc 
     * @param date
     */
    protected parseToDotNetString(date: Date): string {
        return DateHelper.toDotNetDateString(date);
    }

    /**
     * @override
     * @inheritdoc 
     */
    public createPlaceHolder(): KnockoutComputed<string> {
        return this.defineComputed(() => {
            const language = ResourceManager.getInstance().getLanguage();
            return language.datePattern;
        });
    }

    private createLinkViewModel(): LinkViewModelT {
        return new this.LinkViewModel({
            parentLocator: this.locator,
            locator: 'button.open-datepicker',
            tooltip: new this.LabelViewModel({
                ergName: 'DATEPICKER_BUTTON_TOOLTIP'
            }),
            image: new this.ImageViewModel({
                source: GlobalConfiguration.inlineImages.PICKER,
                alternativeText: new this.LabelViewModel({
                    ergName: 'FACTORY_DATEPICKER'
                })
            }),
            isFocusable: this.isFocusable,
            isEnabled: this.isEnabled,
            isToolBarLink: true
        });
    }
}

ComponentManager.setViewModel('KendoDatePickerViewModel', KendoDatePickerViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');